/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
.o-well {
  box-sizing: border-box;
  padding: 1.875em 0.9375em;
  border: 1px solid var(--gray-40);
  background-color: var(--gray-5);
}
@media only all and (min-width: 37.5625em) {
  .o-well {
    padding-left: 1.875em;
    padding-right: 1.875em;
  }
}